import nl from './nl'
import en from './en'

export default {
  en: en,
  'en-US': en
}

export const defaultLocale = 'en'
